import React from "react";


const Home = () => {

    const bgImageUrl = 'bg-30-opacity.png';

    return(
        <React.Fragment>
        <header className="w3-container w3-center w3-light-blue w3-text-black"   
            style={{
                padding: '128px 16px',
                backgroundImage: `url("${bgImageUrl}")`,
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover'
            }}>
            <h1 className="w3-margin w3-jumbo"><b>APRENDER IA</b></h1>
            <h3 className="w3-xlarge">Inteligencia Artificial(IA), Python, Prompting Engineering y Mucho Más... </h3>
            <button className="w3-button w3-yellow w3-padding-large w3-margin-top w3-xxlarge w3-border w3-hover-khaki w3-hover-shadow"><a style ={{textDecoration:'none'}} href="curso-python-ia"><strong>Empieza (Gratuito)</strong></a></button>
            </header>

            <section style={{position: 'relative'}}>
                <div className="custom-shape-divider-bottom-1748060959">
                    <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
                        <path d="M0,0V46.29c47.79,22.2,103.59,32.17,158,28,70.36-5.37,136.33-33.31,206.8-37.5C438.64,32.43,512.34,53.67,583,72.05c69.27,18,138.3,24.88,209.4,13.08,36.15-6,69.85-17.84,104.45-29.34C989.49,25,1113-14.29,1200,52.47V0Z" opacity=".25" className="shape-fill"></path>
                        <path d="M0,0V15.81C13,36.92,27.64,56.86,47.69,72.05,99.41,111.27,165,111,224.58,91.58c31.15-10.15,60.09-26.07,89.67-39.8,40.92-19,84.73-46,130.83-49.67,36.26-2.85,70.9,9.42,98.6,31.56,31.77,25.39,62.32,62,103.63,73,40.44,10.79,81.35-6.69,119.13-24.28s75.16-39,116.92-43.05c59.73-5.85,113.28,22.88,168.9,38.84,30.2,8.66,59,6.17,87.09-7.5,22.43-10.89,48-26.93,60.65-49.24V0Z" opacity=".5" className="shape-fill"></path>
                        <path d="M0,0V5.63C149.93,59,314.09,71.32,475.83,42.57c43-7.64,84.23-20.12,127.61-26.46,59-8.63,112.48,12.24,165.56,35.4C827.93,77.22,886,95.24,951.2,90c86.53-7,172.46-45.71,248.8-84.81V0Z" className="shape-fill"></path>
                    </svg>
                </div>
            </section>
        <div className="w3-row-padding w3-padding-64 w3-container">
            <div className="w3-content">
                <div className="w3-container w3-half">
                    <h1><b>Curso Python IA</b></h1>
                    <h3 className="w3-padding-32">Aprenderemos a usar Python y la Inteligencia Artificial(IA) desde cero.</h3>
                    <p className="w3-large">La duracíon total del curso es de 2.30 Horas + 30 minutos de anexos donde aprenderás a hacer las instalaciones necesarias para empezar a trabajar con la IA desde ya.</p>
                </div>

                <div className="w3-container w3-half w3-center card-image">
                    <div className="w3-card livecard">
                        <h2>Curso Python IA</h2>
                        <img className="card-image"  src="curso-python-ia-2.jpeg" alt="curso python IA (Inteligencia Artificial)" style={{width:'100%'}}/>
                        <div className="w3-container w3-center">
                            <p className="w3-xlarge">Python + IA desde cero</p>
                        </div>
                    </div>
                </div>
            </div>
            </div>

            <section style={{position: 'relative'}}>
            <div className="custom-shape-divider-bottom-1748065471">
                <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
                    <path d="M598.97 114.72L0 0 0 120 1200 120 1200 0 598.97 114.72z" className="shape-fill"></path>
                </svg>
            </div>
            </section>

            <div className="w3-row-padding w3-container w3-black" style={{paddingTop:'64px'}}>
                <div className="w3-content">
                    <div className="w3-container w3-half w3-center card-image">
                        <div className="w3-card w3-white livecard">
                            <h2>Curso Prompt Engineering</h2>
                            <img  className="card-image" src="curso-prompt-engineering.jpeg" alt="curso Prompt Engineering" style={{width:'100%'}}/>
                            <div className="w3-container w3-center">
                                <p className="w3-xlarge">Prompt Engineering desde cero</p>
                            </div>
                        </div>
                    </div>
                    <div className="w3-container w3-half w3-padding">
                    <h1><b>Prompt Engineering</b></h1>
                    <h3 className="w3-padding">Curso de <b>prompt engineering</b> en el que podrás aprender las técnicas más importantes.</h3>
                    <p className="w3-large w3-padding">Aprenderás a comunicar con los lenguajes de gran tamaño (Large Language Models(LLMs)) de forma eficaz.</p>
                    </div>
                </div>
            </div>
        </React.Fragment>

    );
}

export default Home;